import { Button, CloseIcon, Dialog, Flex } from "@fluentui/react-northstar";
import React from "react";
import useDialog from "../../../../hooks/useDialog";
import { useMutation } from "react-query";
import { _api_delete_process_offboarding } from "../../api";
import { ROUTES } from "../../../../constants/routes";
import { useNavigate } from "react-router-dom";
import { useUserOffboarding } from "../../hooks/useUserOffboarding";

const FooterActionButtons = ({
    enableButtonNextStep = false,
    enableButtonBackStep = false,
    isLoadingNextStep = false,
    onClickNextStep = () => console.log("click next step"),
    onClickBackStep = () => console.log("click back step"),
}) => {
    const navigate = useNavigate();

    const [open, setOpen] = useDialog();
    const { user_offboarding, setUserOffboarding } = useUserOffboarding();

    // mutation stop process offboarding
    const { mutate, isLoading } = useMutation(
        (data) => {
            return _api_delete_process_offboarding(data);
        },
        {
            onSuccess: (data) => {
                if (data?.success) {
                    setUserOffboarding(null);
                    return navigate(
                        `${ROUTES.offboarding.home}${location.search}`
                    );
                }
            },
        }
    );

    return (
        <Flex space="between">
            {/* annuler la procédure de lancement d'offboarding */}
            <Dialog
                open={open}
                content="Vous allez perdre toutes les données saisies sur la procédure d'offboarding."
                header={
                    "Êtes-vous sûr.e d'annuler la procédure d'offboarding du collaborateur ?"
                }
                headerAction={{
                    icon: <CloseIcon />,
                    onClick: () => setOpen(false),
                }}
                onConfirm={() => {
                    return mutate({
                        id_user: user_offboarding?.id,
                    });
                }}
                cancelButton={{
                    content: "Annuler",
                    flat: true,
                }}
                onCancel={() => {
                    return setOpen(false);
                }}
                confirmButton={{
                    content: "Annuler la procédure",
                    flat: true,
                    loading: isLoading,
                    styles: {
                        backgroundColor: "var(--color-danger)",
                    },
                }}
                trigger={
                    <Button
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setOpen(true);
                        }}
                        content="Annuler la procédure"
                        text
                        styles={{
                            color: "var(--color-danger)",
                            textDecoration: "underline",
                        }}
                    />
                }
            />
            {/* next/previous step */}
            <Flex gap="gap.small">
                <Button
                    content="Revenir à l'étape précédente"
                    disabled={!enableButtonBackStep}
                    onClick={onClickBackStep}
                    secondary
                    flat
                />
                <Button
                    content="Passer à l'étape suivante"
                    onClick={onClickNextStep}
                    loading={isLoadingNextStep}
                    disabled={!enableButtonNextStep}
                    primary
                    flat
                />
            </Flex>
        </Flex>
    );
};

export default FooterActionButtons;
